import { styled } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { themeColors } from 'src/theme';

const StyledActionItem = styled(GridActionsCellItem, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color?: string }>(({ theme, color }) => ({
  padding: theme.spacing(1.5),
  minWidth: '180px',
  fontSize: '0.875rem',
  fontWeight: 400,
  lineHeight: 1.3,
  color: color ?? themeColors.black,
}));

export default StyledActionItem;
